<script setup lang="ts">
// Formkit schema: https://formkit.com/api-reference/formkit-inputs#formkitschemaextendablesection
import type { UmbracoFormField } from 'types/blocks';

const { getDefaultFormField } = useForm();

defineProps<{
  field: UmbracoFormField;
}>();
</script>

<template>
  <FormKit
    type="email"
    autocomplete="email"
    v-bind="getDefaultFormField(field)"
    aria-autocomplete="list"
    :validation-messages="{
      required: field.requiredErrorMessage || $t('FormMessages.General.Required'),
      email: $t('FormMessages.Error.MustBeValidEmail'),
    }"
    :validation="field.required ? 'required|email' : 'email'"
  />
</template>
